import ethereum from 'decentralized/ethereum.js';
import accounts from 'accounts/Accounts.js';
import ipfs from 'decentralized/Ipfs.js';

export const decryptProject = async (id) => {
    let sequence = await ethereum.guildSequences.getGuildSequence(id);
    if (sequence === undefined && accounts.isLoggedIn()) {
        sequence = await ethereum.encryption.getSequencesSharedWithUser(id);
        sequence = sequence[0];
    }
    if (sequence !== undefined) {
        let j = await ethereum.crypto.fetchAndDecrypt(id, sequence);
        return JSON.parse(j);
    } else {
        // otherwise check if it's encrypted by you, personally
        let encrypted = await ethereum.encryption.getEncryptedSequenceIfAny(id);
        if (encrypted !== undefined) {
            return JSON.parse(await ethereum.crypto.fetchAndDecrypt(id, encrypted));
        } 
    }

    return ipfs.getJson(id);
}
